//配置多个baseURL域名的base.js
const base = {
  //  baseUrl: 'http://47.118.35.234',
  baseUrl: process.env.BASE_API,//'http://192.168.0.119:9804/',
  // uploadUrl: 'http://192.168.1.145:9803'
  // uploadUrl: 'http://47.118.35.234'
  //  baseUrl: 'https://api.mfzcw.com/',
  uploadUrl: process.env.Upload_URL,//'https://api.mfzcw.com/',
  //phoneUrl:'http://192.168.1.198:9806/',
  phoneUrl: process.env.PHONE_URL,//'https://api.mfzcw.com/',
  settlementUrl:process.env.settlement_Url,//'http://192.168.0.188:9809',//'https://api.mfzcw.com/'//'http://192.168.0.188:9809',//'https://api.mfzcw.com'
  mangerUrl:process.env.manger_Url,
  aiPostUrl:process.env.aiPostUrl,
}

export default base;


// WEBPACK FOOTER //
// ./src/request/base.js